module.exports = __webpack_public_path__ + "static/entity-formation-splash-low.7d493cd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/entity-formation-splash-low.jpg
// module id = 879
// module chunks = 229147257040141